import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/circleci-runner/workdir/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
